import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const UserDepositList = createSlice({
  name: "depositlist",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    DSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const { requestStart, DSuccess, requestFailure } =
  UserDepositList.actions;

export const GetDepositlist = (user) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const GetDepositlist = await axios.get(`/private/depositlist`);
    if (GetDepositlist?.data) {
      dispatch(DSuccess(GetDepositlist?.data));
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default UserDepositList.reducer;
